// External deps
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import SelectGeneric from 'ypf-pas-general-ui-components/dist/SelectGeneric/SelectGeneric';
import TextArea from 'ypf-pas-general-ui-components/dist/TextArea/TextArea';
import dayjs from 'dayjs';

// Internal deps
import { getServicesContract } from '../../../../services/yclickMaster';
import { formatsEnum } from '../../../../utils/formatUtils';

const AutomaticService = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();
  const [services, setServices] = useState([]);

  useEffect(() => {
    if (disabled === false) {
      getServicesContract(
        values.provider.providers[0].contract?.id,
        values.ubication.event?.id
      ).then((data) => setServices(data));

      const currentDate = dayjs(new Date()).format(formatsEnum.FORMAT_DATE_2);

      setFieldValue('service.probDate', currentDate);
      setFieldValue('service.needDate', currentDate);
    }
    if (disabled && (values.service.service || values.service.description)) {
      setFieldValue('service.service', null);
      setFieldValue('service.description', '');
      setServices([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  return (
    <div>
      <SelectGeneric
        isDisabled={disabled}
        label="Servicio"
        name="service.service"
        onChange={(val) => {
          setFieldValue('service.service', val);
        }}
        options={services}
        paddingIndicator={4}
        placeholder="Buscar por nombre"
        value={values.service.service}
        withSelect="100%"
      />
      <TextArea
        disabled={disabled}
        label="Descripción"
        maxLength={512}
        name="service.description"
        onChange={(e) => setFieldValue('service.description', e.target.value)}
        placeholder="Detalla el servicio a solicitar"
        value={values.service.description}
      />
    </div>
  );
};

export default AutomaticService;

AutomaticService.propTypes = {
  disabled: PropTypes.bool.isRequired
};
